import { render } from "./TaskToUserTips.vue?vue&type=template&id=287a05d7"
import script from "./TaskToUserTips.vue?vue&type=script&lang=js"
export * from "./TaskToUserTips.vue?vue&type=script&lang=js"

import "./TaskToUserTips.vue?vue&type=style&index=0&id=287a05d7&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__